import axios from "axios";
import { BASE_URL } from "../baseurl"; 

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});



export const pagesApi = {
  async list() {
    const res = await axios.get(`${BASE_URL}/pages`);
    return res.data.pages;
  },

  async get(slug) {
    const res = await axios.get(`${BASE_URL}/pages/${slug}`);
    return res.data.page;
  },

  async update(slug, content) {
    const res = await axios.put(
      `${BASE_URL}/pages/${slug}`,
      content,
      { headers: authHeaders() }
    );
    return res.data.page;
  },
};

export default pagesApi;